import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';
export const calendarApi = createApi({
  reducerPath: 'calendar',

  baseQuery: createBaseQueryWithReauth('/calendar'),

  tagTypes: ['Calendar'],

  endpoints: builder => ({
    getCalendar: builder.query({
      query: (month) => ({
        url: `/month?month=${month}`,
        method: 'GET',
      }),
      providesTags: ['Calendar'],
    }),
    getRegular: builder.query({
      query: () => ({
        url: `/scheduled`,
        method: 'GET',
      }),
      providesTags: ['Calendar'],
    }),
    editWorkDay: builder.mutation({
      query: ({ date, state }) => ({
        url: `/toggle-state?date=${date}&state=${state}`,
        method: 'POST',
      }),
      invalidatesTags: ['Calendar'],
    })
  }),
});


export const {
  useGetCalendarQuery,
  useGetRegularQuery,
  useEditWorkDayMutation
} = calendarApi;
